module.exports = __webpack_public_path__ + "assets/1063d896f58eb2c60df9c89037b2ae86.png";